<template>
    <div class="layer">
        <h1 class="page-title">유저 {{isAddMode ? '생성' : '수정'}}
            <el-tag type="danger">개인정보 취급 주의!!</el-tag>
        </h1>
        <el-form class="user-form"
                 ref="form"
                 :model="form"
                 label-width="140px">
            <el-form-item label="유저ID" v-if="!isAddMode">
                <el-tag type="info">{{form.userId}}</el-tag>
            </el-form-item>
            <el-form-item label="이름" required>
                <el-input v-model="form.name"
                          maxlength="20"
                          show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="소개">
                <el-input type="textarea"
                          rows="4"
                          v-model="form.description"
                          maxlength="300"
                          show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="전화번호" required v-if="isAddMode">
                <el-input v-model="form.phone"
                          placeholder="'-' 제외 입력"
                          maxlength="11"
                          show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="전화번호" v-else>
                <el-tag type="info">{{form.phone}}</el-tag>
            </el-form-item>
            <el-form-item label="섬네일">
                <ImageUploadButton :on-upload="onUpload" :max-size="0.5"/>
                <img :src="thumbnailUrl" :alt="form.name" v-if="thumbnailUrl" width="80px">
                <el-button type="danger" size="mini" v-if="thumbnailUrl" @click.prevent="removeThumbnail">제거</el-button>
            </el-form-item>
            <el-form-item label="마지막 로그인" v-if="!isAddMode">
                <el-tag type="info">{{form.lastLogin | dateTime}}</el-tag>
            </el-form-item>
            <el-form-item label="가입일" v-if="!isAddMode">
                <el-tag type="info">{{form.createdAt | dateTime}}</el-tag>
            </el-form-item>
            <el-form-item label="마지막 수정일" v-if="!isAddMode">
                <el-tag type="info">{{form.updatedAt | dateTime}}</el-tag>
            </el-form-item>
            <el-form-item label="현재 상태" required>
                <el-switch v-model="form.isValid"
                           active-color="#13ce66"
                           inactive-color="#ff4949"
                           active-text="정상"
                           inactive-text="정지">
                </el-switch>
            </el-form-item>
            <el-form-item label="권한" v-if="!isAddMode">
                <el-tag type="warning"
                        effect="dark"
                        v-for="item in form.permissions" :key="item.permission">{{item.permission}}
                </el-tag>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-if="isTouched" @click.prevent="submit">{{isAddMode ? '생성' : '수정'}}
                </el-button>
                <el-button @click.prevent="back">취소</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {USER_RESET_EDIT_USER} from '@/store/modules/user';
    import imageController from '@/components/mixins/imageController';
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';
    import errorController from '@/components/mixins/errorController';
    import {ROUTE_USERS} from '@/router/routeNames';
    import ImageUploadButton from '@/components/ImageUploadButton';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'UserEdit',
        components: {ImageUploadButton},
        mixins: [imageController, errorController],
        data() {
            return {
                form: {},
                isChangeThumbnail: false,
                thumbnailUrl: null,
            };
        },
        computed: {
            isAddMode() {
                return this.$store.state.user.isAddMode;
            },
            user() {
                return this.$store.state.user.edit;
            },
            isTouched() {
                return Object.keys(this.user).some(key => this.user[key] !== this.form[key]) || this.isChangeThumbnail;
            },
        },
        methods: {
            back() {
                this.$router.back();
            },
            onUpload(base64) {
                this.isChangeThumbnail = true;
                this.thumbnailUrl = base64;
            },
            removeThumbnail() {
                this.isChangeThumbnail = true;
                this.thumbnailUrl = null;
            },
            async submit() {
                const request = {};
                if (this.isAddMode) {
                    request.phone = this.form.phone;
                } else {
                    request.userId = this.user.userId;
                    request.phone = this.user.phone;
                }
                request.name = this.form.name?.trim();
                request.description = this.form.description?.trim();
                request.isValid = !!this.form.isValid;

                if (this.isChangeThumbnail) {
                    if (this.thumbnailUrl) {
                        request.imagePath = await this.uploadImage(this.thumbnailUrl);
                    } else {
                        request.imagePath = null;
                    }
                }

                await this.createOrUpdateUser(request);
            },
            async createOrUpdateUser(user) {
                try {
                    await PrintingDiyRepository.postCreateOrUpdateUser(user);
                    this.$message({
                        message: '정상 처리 되었습니다.',
                        type: 'success',
                    });
                    this.$router.replace({name: ROUTE_USERS});
                } catch (err) {
                    this.displayApiError(err);
                }
            },
        },
        created() {
            this.form = {...this.user};
            this.thumbnailUrl = this.form.imagePath && this.getImageFullPath(this.form.imagePath);
        },
        destroyed() {
            this.$store.dispatch(USER_RESET_EDIT_USER);
        },
    };
</script>

<style lang="scss" scoped>
    .user-form {
        width: 800px;
    }
</style>